import React from 'react';
import { Logo } from './Logo';
import { navLinks, site } from '../data/site';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-ink pb-24 pt-16 text-white lg:pb-10" data-id="element-140" data-mp="3ghc0bvkn0rl2">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] lg:px-8" data-id="element-141" data-mp="32p5lqdx4usnq">
        <div data-id="element-142" data-mp="36pzeplpfmxnh">
          <div className="[&_span.text-ink]:text-brand" data-id="element-143" data-mp="36nd6djupwe47">
            <Logo inverted data-id="element-144" data-mp="3ug3efhzi2d97" />
          </div>
          <p className="mt-5 max-w-sm text-white/65" data-id="element-145" data-mp="3ucxs2ai99ph6">
            Quality, affordable home maintenance and repair for the Las Vegas Valley. Local, family-owned and
            guaranteed.
          </p>
          <a href={site.phoneHref} className="mt-5 inline-block font-display text-3xl font-bold text-brand" data-id="element-146" data-mp="3lgop4lv2k8qa">
            {site.phone}
          </a>
        </div>
        <nav aria-label="Footer" data-id="element-147" data-mp="29ydvry6nv08u">
          <p className="font-display text-lg font-bold uppercase text-white/50" data-id="element-148" data-mp="2a19qzer4jatl">Company</p>
          <ul className="mt-4 space-y-2.5" data-id="element-149" data-mp="2ew6zmkkhri5y">
            {navLinks.map(l => <li key={l.href} data-id="element-150" data-mp="3la290texx1up">
                <a href={l.href} className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-151" data-mp="3lbdaunotrzj6">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div data-id="element-152" data-mp="3q8wphopfqebn">
          <p className="font-display text-lg font-bold uppercase text-white/50" data-id="element-153" data-mp="3q8dkf8kvvkf1">Popular services</p>
          <ul className="mt-4 space-y-2.5" data-id="element-154" data-mp="828ni7pom7a7">
            {services.slice(0, 6).map(s => <li key={s.id} data-id="element-155" data-mp="34gx5i4oqt84">
                <a href="#services" className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-156" data-mp="335pv8c173c9">
                  {s.name}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col justify-between gap-2 border-t border-white/10 px-5 pt-6 text-sm text-white/50 sm:flex-row lg:px-8" data-id="element-157" data-mp="cvtmo330h7az">
        <p data-id="element-158" data-mp="mt7sl8rb6dp1">© {new Date().getFullYear()} Home Repair, MD. All rights reserved.</p>
        <p data-id="element-159" data-mp="tvw6yepkdbex">{site.license}</p>
      </div>
    </footer>;
}